
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'

import {
SaafHeader,
SaafFooter,
SaafImageUpload,
} from '@/common/components/index'
import { mapState } from 'vuex'

import service from '@/common/tool/service'
import nativeApi from '@/common/tool/nativeApi'
import { setTimeout } from 'timers';



export default {
data () {
return {
fileList:[]
}
},
components: {
SaafHeader,
SaafFooter,
SaafImageUpload,
XButton,
XInput,
Group,
},
computed: {
...mapState({
userInfo: state => state.user.userInfo,
}),
},
created(){
setTimeout(()=>{
this.fileList = [{
accessPath: "https://aus-auportal.oss-cn-shanghai.aliyuncs.com/img/58c0844e27be46eaaf66e7ce7837cd58.JPG",
bucketName: "aus-auportal",
createdBy: "2220002",
createdByUser: "张三",
creationDate: "2018-10-27 14:43:34",
fileId: 1110062,
fileName: "IMG_0002.JPG",
filePath: "https://aus-auportal.oss-cn-shanghai.aliyuncs.com/img/58c0844e27be46eaaf66e7ce7837cd58.JPG",
fileSize: 65549,
fileStoreSystem: 1,
fileType: ".JPG",
remoteFileName: "58c0844e27be46eaaf66e7ce7837cd58.JPG",
sourceFileName: "IMG_0002.JPG",
uploadDate: "2018-10-27 14:43:33",
},{
accessPath: "https://aus-auportal.oss-cn-shanghai.aliyuncs.com/img/58c0844e27be46eaaf66e7ce7837cd58.JPG",
bucketName: "aus-auportal",
createdBy: "2220002",
createdByUser: "张三",
creationDate: "2018-10-27 14:43:34",
fileId: 1110062,
fileName: "IMG_0002.JPG",
filePath: "https://aus-auportal.oss-cn-shanghai.aliyuncs.com/img/58c0844e27be46eaaf66e7ce7837cd58.JPG",
fileSize: 65549,
fileStoreSystem: 1,
fileType: ".JPG",
remoteFileName: "58c0844e27be46eaaf66e7ce7837cd58.JPG",
sourceFileName: "IMG_0002.JPG",
uploadDate: "2018-10-27 14:43:33",
},
{
accessPath: "https://aus-auportal.oss-cn-shanghai.aliyuncs.com/img/91f83320c7a44f4bb255b72fe55c7cbd.jpg",
bucketName: "aus-auportal",
createdBy: "2220002",
createdByUser: "张三",
creationDate: "2018-10-27 14:43:34",
fileId: 1110062,
fileName: "IMG_0002.JPG",
filePath: "https://aus-auportal.oss-cn-shanghai.aliyuncs.com/img/91f83320c7a44f4bb255b72fe55c7cbd.jpg",
fileSize: 65549,
fileStoreSystem: 1,
fileType: ".JPG",
remoteFileName: "58c0844e27be46eaaf66e7ce7837cd58.JPG",
sourceFileName: "IMG_0002.JPG",
uploadDate: "2018-10-27 14:43:33",
},
{
accessPath: "511",
createdBy: "62169",
createdByUser: "赵湘萍",
creationDate: "2018-10-27 15:04:58",
fileId: 1970,
fileName: "澳优项目双周工作计划-EMS_2018.10.23.xlsx",
filePath: "511",
fileSize: 24742,
fileStoreSystem: 2,
fileType: "xlsx",
remoteFileName: "澳优项目双周工作计划-EMS_2018.10.23.xlsx",
sourceFileName: "澳优项目双周工作计划-EMS_2018.10.23.xlsx",
uploadDate: "2018-10-27 15:04:58"
},{
accessPath: "511",
createdBy: "62169",
createdByUser: "赵湘萍",
creationDate: "2018-10-27 15:04:58",
fileId: 1970,
fileName: "澳优项目双周工作计划双周工作计划-EMS_2018.10.23.xlsx",
filePath: "511",
fileSize: 24742,
fileStoreSystem: 2,
fileType: "ppt",
remoteFileName: "澳优项目双周工作计划-EMS_2018.10.23.xlsx",
sourceFileName: "澳优项目双周工作计划-EMS_2018.10.23.xlsx",
uploadDate: "2018-10-27 15:04:58"
},{
accessPath: "511",
createdBy: "62169",
createdByUser: "赵湘萍",
creationDate: "2018-10-27 15:04:58",
fileId: 1970,
fileName: "澳优项目双周工作计划双周工作计划-EMS_2018.10.23.xlsx",
filePath: "511",
fileSize: 24742,
fileStoreSystem: 2,
fileType: "doc",
remoteFileName: "澳优项目双周工作计划-EMS_2018.10.23.xlsx",
sourceFileName: "澳优项目双周工作计划-EMS_2018.10.23.xlsx",
uploadDate: "2018-10-27 15:04:58"
}]
},3000)
},
methods: {

},
watch:{
},
mounted(){

},
}




// WEBPACK FOOTER //
// ./src/page/demo/ImageUpload.vue